import { defineElement, BaseElement } from '@webtides/element-js';

export default class UsercentricsLegacyLink extends BaseElement {
    events() {
        return {
            window: {
                UC_UI_INITIALIZED: event => this.findLegacyLinks(),
            },
        };
    }

    findLegacyLinks() {
        /**
         * maps old UC cookie settings to new UI
         */
        const ucLinks = document.querySelectorAll('[href="#uc-corner-modal-show"]');
        ucLinks.forEach(link => {
            link.addEventListener('click', e => {
                if (window.UC_UI) {
                    e.preventDefault();
                    e.stopPropagation;
                    window.UC_UI.showSecondLayer();
                }
            });
        });
    }
}

defineElement('usercentrics-legacy-link', UsercentricsLegacyLink);
